/* eslint-disable */
import * as React from 'react'
import classnames from 'classnames'
import Modal from 'react-modal'
import Button from '../Button'
import { DialogContainer } from './dialog.module.less'

const customStyles = {
  overlay: {
    background: 'transparent'
  },
};

export enum ButtonDirection {
  ROW = 'row',
  ROW_REVERSE = 'row_reverse',
  COLUMN = 'column',
  COLUMN_REVERSE = 'column_reverse'
}

interface DialogParams {
  className?: string;
  visible: boolean;
  title?: string;
  buttonDirection?: ButtonDirection | string;
  width?: number;
  hideFooter?: boolean;
  hideCancel?: boolean;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: React.MouseEventHandler<HTMLElement>,
  onCancel?: React.MouseEventHandler<HTMLElement>,
  onClose?: React.MouseEventHandler<HTMLElement>,
}

const Dialog: React.FC<DialogParams> = (params) => {
  const {
    className,
    visible,
    title,
    buttonDirection,
    children,
    width = 520,
    hideFooter=false,
    hideCancel = false,
    confirmText = '确定',
    cancelText = '取消',
    onConfirm,
    onCancel,
    onClose
  } = params;

  return <Modal 
    className={classnames(DialogContainer, className)} 
    isOpen={visible}
    style={customStyles}
    ariaHideApp={false}>
      <div className="dialog-wrap">
        <div className="dialog-content" style={{width: width}}>
          <div className="dialog-header">
            <h3 className="dialog--title">{title}</h3>
            <Button btnType="text" size="small" className="dialog--icon-close" onClick={onClose}>
              <i className="icon icon-close"></i>
            </Button>
          </div>
          <div className="dialog-body">
            {children}
          </div>
          {!hideFooter && <div className={classnames("dialog-footer", buttonDirection)}>
            {!hideCancel && <Button btnType="secondary" size="small" onClick={onCancel}>{cancelText}</Button>}
            {!hideCancel && <div className="space" style={{width: 20, height: 20}}></div>}
            <Button btnType="primary" size="small" onClick={onConfirm}>{confirmText}</Button>
          </div>}
        </div>
      </div>
  </Modal>
}

export default Dialog;

/* eslint-disable no-new */